import React, { useState } from 'react';
import { GarmentsHorizontalScrollContextType } from './types/GarmentsHorizontalScrollContextType';

export const GarmentsHorizontalScrollContext =
  React.createContext<GarmentsHorizontalScrollContextType | null>(null);

type GarmentsHorizontalScrollProviderProps = {
  children: React.ReactNode;
};

const GarmentsHorizontalScrollProvider: React.FC<
  GarmentsHorizontalScrollProviderProps
> = ({ children }) => {
  const [scrollSize, setScrollSize] = useState(0);
  const saveScrollSize = (size: number) => {
    setScrollSize(size);
  };
  return (
    <GarmentsHorizontalScrollContext.Provider
      value={{ scrollSize, saveScrollSize }}
    >
      {children}
    </GarmentsHorizontalScrollContext.Provider>
  );
};

export default GarmentsHorizontalScrollProvider;
